import { render } from "./OurTeam.vue?vue&type=template&id=5216e3e0"
import script from "./OurTeam.vue?vue&type=script&lang=js"
export * from "./OurTeam.vue?vue&type=script&lang=js"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__